/* eslint-disable */
import React, { useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../utils/functions/api';
import Loading from '../Loading';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Slide from '@mui/material/Slide';
import { forwardRef } from 'react';

const CreditCardPopup = ({
  open,
  onClose,
  CreditCardImage,
  bank,
  tokens,
  etaxData,
  payType,
  language,
  dialogTermsOpen,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const urlOPS = useRef('');
  const formOPS = useRef('');

  // const Transition = forwardRef(function Transition(props, ref) {
  //   return <Slide direction="up" ref={ref} {...props} />;
  // });

  const handlePaymentClick = async () => {
    setIsLoading(true);
    const CreditBank = bank[0].bankName;
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_APIHOST}/createpayment`,
        {
          source: `CR ${bank} ${etaxData?.branchCode ?? ''} ${
            etaxData?.tax ?? ''
          } ${etaxData?.postalCode ?? ''}`,
          eTaxData: {
            BUYER_NAME: etaxData?.name,
            BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
            BUYER_TAX_ID: etaxData?.taxId,
            BUYER_BRANCH_ID: etaxData?.branchCode,
            BUYER_POST_CODE: etaxData?.postalCode,
            BUYER_ADDRESS_LINE1: etaxData?.address,
            BUYER_ADDRESS_LINE2: etaxData?.address2,
          },
          etaxname: etaxData?.etaxname ?? '',
          etaxaddress1: etaxData?.etaxaddress1 ?? '',
          etaxaddress2: etaxData?.etaxaddress2 ?? '',
          email: etaxData?.email ?? '',
          term: payType === 'IN' ? etaxData?.term : null,
          card_id: etaxData?.select_card?.card_id ?? '',
        },
        { headers: { Authorization: tokens } },
      );
      if (data.status === 'paid' && data.company_callback) {
        navigate(
          `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'paid' && !data.company_callback) {
        navigate(
          `/transactionResult?status=success&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending' && data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending' && !data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'cancel' && !data.company_callback) {
        navigate(
          `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else {
        urlOPS.current = data.tagUrl;
        formOPS.current = data.tagInput;
        setIsLoading(false);
        setTimeout(() => {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = urlOPS.current;
          form.innerHTML = formOPS.current;
          document.body.appendChild(form);
          form.submit();
        }, 750);
      }
    } catch (error) {
      console.error('Error processing payment:', error);
    }
  };

  return (
    <Dialog
      open={open} // ✅ แสดง Dialog ตามเงื่อนไขเดิม
      onClose={onClose}
      // TransitionComponent={Transition} // ✅ เพิ่ม Animation เลื่อนขึ้น
      PaperProps={{
        sx: {
          borderRadius: '15px',
          maxWidth: 500,
          width: '100%',
        },
      }}
    >
      <Loading isLoading={isLoading} />

      {/* หัวข้อ */}
      <DialogTitle
        sx={{
          fontWeight: 'bold',
          fontSize: '18px',
          textAlign: 'center',
          marginTop: '10px',
        }}
      >
        {language === 'TH'
          ? 'ช่องทางการชำระผ่าน Credit Card'
          : 'Credit Card Payment Options'}
      </DialogTitle>

      <DialogContent>
        {/* โลโก้บัตร */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 1,
            marginBottom: 3,
          }}
        >
          <img
            src={CreditCardImage}
            alt="CreditCard"
            style={{ width: '85%', maxWidth: '400px' }}
          />
        </Box>

        {/* กล่องข้อความแจ้งเตือน (แสดงเฉพาะเมื่อ dialogTermsOpen เป็น true) */}
        {dialogTermsOpen && (
          <Box
            sx={{
              backgroundColor: '#F5FAFF',
              borderRadius: '10px',
              padding: '16px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1.5,
              // border: '1px solid #276EF1',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)',
            }}
          >
            <LockOutlinedIcon sx={{ color: '#276EF1', fontSize: '56px' }} />
            <Box sx={{ fontSize: '14px', color: '#333' }}>
              <strong>
                {language === 'TH'
                  ? 'เพื่อความปลอดภัย กรุณาเปิดใช้ระบบ 3D Secure'
                  : 'For your security Please enable 3D Secure'}
              </strong>
              {/* <br />
              <strong>
                {language === 'TH'
                  ? 'กรุณาเปิดใช้ระบบ 3D Secure'
                  : 'Please enable 3D Secure'}
              </strong> */}
              <br />
              {language === 'TH'
                ? ' (Verified by Visa / Mastercard) กับธนาคารผู้ออกบัตรก่อนดำเนินการชำระเงิน'
                : ' (Verified by Visa / Mastercard) with your card issuer before proceeding with payment.'}
            </Box>
          </Box>
        )}
      </DialogContent>

      {/* ปุ่ม */}
      <DialogActions sx={{ justifyContent: 'center', marginBottom: 3 }}>
        <Button
          onClick={onClose}
          sx={{
            width: '100px',
            border: '1px solid #FC3A3A',
            color: '#FC3A3A',
            backgroundColor: '#fff',
            '&:hover': { backgroundColor: 'rgba(252,58,58,0.1)' },
          }}
        >
          {language === 'TH' ? 'ยกเลิก' : 'Cancel'}
        </Button>
        <Button
          onClick={handlePaymentClick}
          sx={{
            width: '100px',
            border: '1px solid #51D245',
            color: '#51D245',
            backgroundColor: '#fff',
            '&:hover': { backgroundColor: 'rgba(81,210,69,0.1)' },
          }}
        >
          {language === 'TH' ? 'ยืนยัน' : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreditCardPopup;
